import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#FFF' : props.fill;
  const width = !size && !props.width ? 24 : props.width;
  const height = !size && !props.height ? 24 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 24 24"
      >
        <path
          d="M13.10625 0l4.61625 4.614375L22.336875 0H13.10625zM0 0v12.12375L12.12375 0H0zm17.7225 7.798125l-5.1075-5.1075L0 15.305625V24h5.01375V13.021875h3.75V24h1.965V8.7375h3.75V24h1.966875V11.1485625h3.75V24H24V1.51875l-6.2775 6.279375z"
          fill="#FFF"
          fillRule="evenodd"
        />
      </svg>
    </span>
  );
};

export default SvgIcon;
